import mitt from 'mitt'

type Events = {
  // 通知刷新plan列表
  refreshPlanList: void
}

const emitter = mitt<Events>()
export default emitter
